// create a hook to get the search params as an object
import { useMemo } from 'react'
import { useSearchParams } from 'react-router'

export default function useSearchParamsAsObject() {
  const [searchParams] = useSearchParams()

  const searchParamsObject = useMemo(() => {
    return Object.fromEntries(searchParams.entries())
  }, [searchParams])

  return searchParamsObject
}
